// extracted by mini-css-extract-plugin
export default {"loginView":"login_loginView__ZN9bD","provider":"login_provider__m2OOW","googleLogo":"login_googleLogo__KiCx2"};